import React from 'react'
import NotifTable from '../../components/NotifTable'
import { Box } from '@mui/system'

const Notification = () => {
  return (
    <Box sx={{marginTop:"40px"}}>

      <NotifTable/>
    </Box>
  )
}

export default Notification